import { useEffect, Component } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/troy/Header";
import FeedbackPromo from "./components/troy/FeedbackPromo";
import Hero from "./components/troy/Hero";
import RideRequest from "./components/troy/RideRequest";
import About from "./components/troy/About";
import Services from "./components/troy/Services";
import Passengers from "./components/troy/Passengers";
import Prizes from "./components/troy/Prizes";
import Drivers from "./components/troy/Drivers";
import Testimonials from "./components/troy/Testimonials";
import Feedback from "./components/troy/Feedback";
import Footer from "./components/troy/Footer";
import FloatingWhatsApp from "./components/troy/FloatingWhatsApp";
import Admin from "./pages/Admin";

function Landing() {
  useEffect(() => {
    document.title = "Troy Transportes — Grupo de Transporte | General Carneiro e região";
  }, []);
  return (
    <div className="bg-[#08080A] text-white min-h-screen">
      <Header />
      <main>
        <FeedbackPromo />
        <Hero />
        <RideRequest />
        <About />
        <Services />
        <Passengers />
        <Prizes />
        <Drivers />
        <Testimonials />
        <Feedback />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

class RecoveryBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, retries: 0 };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {
    if (this.state.retries < 2) {
      setTimeout(
        () => this.setState((s) => ({ hasError: false, retries: s.retries + 1 })),
        150
      );
    }
  }
  render() {
    if (this.state.hasError && this.state.retries >= 2) {
      return (
        <div className="min-h-screen bg-[#08080A] text-white flex flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="font-bold text-lg">Ops! Algo interferiu na página.</p>
          <button
            onClick={() => window.location.reload()}
            data-testid="recovery-reload-btn"
            className="bg-[#FFCC00] text-black font-bold py-3 px-8 rounded-xl"
          >
            Recarregar o site
          </button>
        </div>
      );
    }
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default function App() {
  return (
    <div className="App">
      <RecoveryBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </RecoveryBoundary>
      <Toaster position="top-center" richColors theme="dark" />
    </div>
  );
}
